import React, { useState } from "react";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import HttpReqConfiguration from "./HttpReqConfiguration";

import HttpRawPermissions from "./HttpRawPermissions";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";

const HttpRequestTemplateEditor = ({ file, selectedApiData, setSelectedApiData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(selectedApiData);

  const handleSaveHttpRequest = async () => {
    try {
      setIsSaving(true);
      const payload = {
        ...selectedApiData,
        name: file.name
      };
      const { message } = await axiosInstance.put(`/http-request-templates/${file.id}`, payload);
      toastSuccess(message);
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <GenericActionBar
        path={
          <div>
            <em>API</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveHttpRequest
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />
      <div className="page_main_section p_0">
        <BuilderTabs
          tabs={[
            {
              label: "Configuration",
              content: (
                <div style={{ maxWidth: "640px", margin: "0 auto" }}>
                  <HttpReqConfiguration selectedApiData={selectedApiData} setSelectedApiData={setSelectedApiData} />
                </div>
              )
            },
            {
              label: "Permissions",
              content: (
                <div style={{ maxWidth: "640px", margin: "0 auto" }}>
                  <HttpRawPermissions selectedApiData={selectedApiData} setSelectedApiData={setSelectedApiData} />
                </div>
              )
            }
          ]}
          tabsClass={"activity_tab"}
          containerClass={"page-action-bar-top align-start"}
          contentStyle={{ height: "calc(100% - 48px)", padding: "20px", overflow: "auto" }}
        />
      </div>
    </div>
  );
};

export default HttpRequestTemplateEditor;
